// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from AddonAfter.module.scss  */
.AddonAfter-module-Root_24v {
  display: inline-flex;
  align-items: center;
  padding-top: 2px;
  padding-right: 1rem;
  cursor: pointer;
  border: 0;
  border-radius: 0.5rem;
  background: transparent; }

.AddonAfter-module-Icon_198 {
  pointer-events: none;
  fill: #9199a3; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/_internal_/components/AddonAfter/AddonAfter.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,uBAAuB,EAAE;;AAE3B;EACE,oBAAoB;EACpB,aAAa,EAAE","sourcesContent":["/*  imported from AddonAfter.module.scss  */\n.AddonAfter-module-Root_24v {\n  display: inline-flex;\n  align-items: center;\n  padding-top: 2px;\n  padding-right: 1rem;\n  cursor: pointer;\n  border: 0;\n  border-radius: 0.5rem;\n  background: transparent; }\n\n.AddonAfter-module-Icon_198 {\n  pointer-events: none;\n  fill: #9199a3; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
